import {
  Component,
  OnInit,
} from '@angular/core';
import {
  NgbActiveModal,
} from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';

@Component({
  standalone: false,
  selector: 'app-modal-buat-pin',
  templateUrl: './buat-pin.component.html',
  styleUrls: ['./buat-pin.component.scss'],
})
export class BuatPinComponent implements OnInit {
  contentText: string = '';

  constructor(
    private activeModal: NgbActiveModal,
    private route: Router,
  ) {}
  ngOnInit(): void {
    let currentUrl = this.route.url;

    if (currentUrl === '/bank-account') {
      this.contentText =
        'Create a PIN for security when withdrawing your balance. Enter your 6-digit PIN and make sure you remember it.';
    } else {
      this.contentText =
        `You haven't created a PIN, add your PIN to continue your balance withdrawal request.`;
    }
  }

  handleClose(e: any): void {
    let currentUrl = this.route.url;

    if (currentUrl === '/bank-account') {
      this.route.navigate(['/profile']);
      this.activeModal.dismiss();
    } else {
      this.activeModal.dismiss();
    }
  }

  handleConfirm(e: any): void {
    this.route.navigate(['pin']);
    this.activeModal.dismiss();
  }
}
